import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useUser } from '@src/state/user';

const Contact = styled('text', {
  color: '#196ECF',
});

export const ValidationInfoModal = ({ isOpen, closeModal, errorCode }) => {
  const { isAPIMarketPlaceUser } = useUser.state();
  const payment =
    'Maximum Payment Information validation attempts reached, please proceed with another validation method.';
  const claim =
    'Maximum Claim and Member Information validation attempts reached, please proceed with another validation method.';
  const usMail =
    'Maximum US Mail validation attempts reached, please proceed with another validation method.';
  const [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    if (errorCode === 'CLAIM') {
      setErrorMessage(claim);
    } else if (errorCode === 'PAYMENT') {
      setErrorMessage(payment);
    } else if (errorCode === 'MAIL') {
      setErrorMessage(usMail);
    }
  }, [errorCode]);
  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      closeOnClickOutside={false}
      showCloseButton={false}
      onClose={closeModal}
      title={errorMessage}
      footer={
        <Modal.Section style={{ float: 'right', paddingTop: '0px' }}>
          <Button onClick={closeModal}>OK</Button>
        </Modal.Section>
      }
    >
      {!isAPIMarketPlaceUser && errorCode === 'MAIL' ? (
        <Modal.Section style={{ paddingBottom: '0px' }}>
          For additional assistance, please contact our UnitedHealthcare Web
          Support team by clicking the chat icon on the bottom right of this
          screen. Support is also available by calling 866-842-3278, option 1.
        </Modal.Section>
      ) : (
        errorCode === 'MAIL' && (
          <Modal.Section style={{ paddingBottom: '0px' }}>
            If you are unable to validate using another method, please contact
            us at <Contact>apiconsultant@uhc.com</Contact>
          </Modal.Section>
        )
      )}
    </Modal>
  );
};

ValidationInfoModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  errorCode: PropTypes.string,
  isOpen: PropTypes.bool,
};
ValidationInfoModal.defaultProps = {
  isOpen: false,
  errorCode: '',
};
